import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpTV'

export const proposalList = (params = '') => Http.get(`/admin/proposals${serialize(params)}`)
export const proposalShow = (id) => Http.get(`/admin/proposals/${id}`)
